var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-uploader',{attrs:{"after-read":_vm.afterRead}}),_c('van-image',{staticClass:"img-show",attrs:{"src":_vm.showImageSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }